<template>
  <div class="page-maindiv">
    <!-- Main -->
    <div class="area-main">
      <!-- Area titolo -->
      <div class="area-top">
        <div class="area-top-title">
          {{ $t('cagranda').toUpperCase() }}
        </div>
      </div>
      <div class="area-description-container">
        <div class="area-description" v-html="pageDescription"></div>
        <div class="youtubevideo-container" v-if="this.$i18n.locale == 'it'">
          <iframe class="youtubevideo" src="https://www.youtube.com/embed/yzj_0aKLrAc" title="Cà Granda" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <!-- Area cards -->
      <div class="results-cards">
        <div class="spinner-div"><b-spinner class="spinner" label="Busy" v-if="loading"></b-spinner></div>
          <b-card
              class="results-card"
              no-body
              border-variant="white"
              v-for="(collection, index) in filteredCollections"
              :key="collection.id"
          >
          <div @mouseover="hoverCard(index)" @mouseout="hoverCard(-1)">
            <b-link :to="{name: 'assets', params: {idCollection: collection.id, previousPageLink: '/cagranda', previousPageTitle: $t('cagranda')}}" style="text-decoration: none;color: #2c3e50">
              <b-card-img-lazy class="results-card-image" :class="{'selected': isCardSelected(index)}" :src="collection.immagine" :alt="collection.nome" top></b-card-img-lazy>
              <b-card-text class="results-card-description" :class="{'selected': isCardSelected(index)}">
                <p v-html="collection.descrizione"></p>
              </b-card-text>
            </b-link>
          </div>
          <b-card-text class="results-card-num-results" style="margin-left: 15px;">
            <p class="mb-0">{{ collection.nAssets + " " + $tc("beni_visibili-n", collection.nAssets) }}</p>
            <div style="display: flex">
              <p class="mb-0">{{ collection.num_immagini }}<b-icon class="ml-1 mr-3" icon="image"></b-icon></p>
<!--              <p class="mb-0">{{ collection.num_audio }}<b-icon class="ml-1 mr-3" icon="headphones"></b-icon></p>-->
              <p class="mb-0">{{ collection.num_video }}<b-icon class="ml-1" icon="camera-reels"></b-icon></p>
<!--              <p class="mb-0">{{ collection.num_altro }}<b-icon class="ml-1" icon="box"></b-icon></p>-->
            </div>
          </b-card-text>
          <b-link :to="{name: 'assets', params: {idCollection: collection.id, previousPageLink: '/cagranda', previousPageTitle: $t('cagranda')}}" style="text-decoration: none;color: #2c3e50" @mouseover="hoverCard(index)" @mouseout="hoverCard(-1)">
            <b-card-text class="results-card-title" style="margin-left: 15px;">
              {{ collection.nome }}
            </b-card-text>
          </b-link>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CaGranda',
  data: function() {
    return {
      collections: [],
      selectedCard: -1,
      sort: 1, // 1: AZ, -1: ZA
      loading: true,
      pageDescriptionRecord: null,
    };
  },
  created() {
    this.fetchCollections()
  },
  computed: {
    filteredCollections() {
      const collections = this.collections;
      for (let collection in collections) {
        // Compila nome e descrizione
        collections[collection].nome = this.$utilities.getTranslation(collections[collection], "nome", this.$i18n.locale);
        collections[collection].descrizione = this.$utilities.getTranslation(collections[collection], "descrizione_breve", this.$i18n.locale);
      }
      return collections.sort((a, b) => {
        return a.ordine - b.ordine;
      })
    },
    pageDescription() {
      let desc = "";
      if (this.pageDescriptionRecord != null)
        for (let trad in this.pageDescriptionRecord["traduzioni"]) {
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith("it"))
            desc = this.pageDescriptionRecord["traduzioni"][trad].descrizione;
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith(this.$i18n.locale))
            desc = this.pageDescriptionRecord["traduzioni"][trad].descrizione;
        }
      return desc;
    },
  },
  methods: {
    async fetchCollections() {
      const structuresData = await this.$client.getItems("dipartimenti", {fields: ["*", "traduzioni.*"], filter: {
          tipologia: { eq: 'cagranda' }
        }});
      let structures = structuresData.data;

      if (structures !== null && structures.length > 0)
        this.pageDescriptionRecord = structures[0];

      const collectionsData = await this.$client.getItems("collezioni", {fields: ["*", "traduzioni.*"]});
      let collections = [];
      for (let coll in collectionsData.data) {
        let found = false;
        for (let structure in structures) {
          if (structures[structure].id == null || collectionsData.data[coll].id_dipartimento == null)
            continue;
          if (structures[structure].id === collectionsData.data[coll].id_dipartimento.id) {
            collections.push(collectionsData.data[coll]);
            found = true;
            break;
          }
        }
        if (!found)
          continue;
      }
      let collectionIds = [];
      for (let coll in collections) {
        collectionIds.push(collections[coll].id);
        collections[coll].nAssets = 0;
        collections[coll].nome = "";
        const defaultImageUrl = await this.$client.getAssetUrl("cl4ladr0lo8w4ck0", {key: "directus-large-contain"});
        if (collections[coll].immagine != null) {
          const imageId = "" + collections[coll].immagine.id;
          const fileData = await this.$client.getFile(imageId);
          collections[coll].immagine = fileData;
          let file = fileData.data;
          const assetUrl = await this.$client.getAssetUrl(file.private_hash, {key: "directus-large-contain"});
          collections[coll].immagine = assetUrl;
        } else {
          collections[coll].immagine = defaultImageUrl;
        }
      }

      const assetsData = await this.$client.getItems("beni", {fields: ["id", "id_collezione"], filter: {
        id_collezione: {
          in: collectionIds
        }}});
      let assets = assetsData.data;
      for (let asset in assets) {
        for (let coll in collections) {
          if (collections[coll].id === assets[asset].id_collezione) {
            collections[coll].nAssets++;
          }
        }
      }
      this.collections = collections;
      this.loading = false;
    },
    hoverCard(selectedIndex) {
      this.selectedCard = selectedIndex
    },
    isCardSelected (cardIndex) {
      return this.selectedCard === cardIndex
    },
    hoverStructure(selectedIndex) {
      this.selectedStructure = selectedIndex
    },
    isStructureSelected(structureIndex) {
      return this.selectedStructure === structureIndex
    },
    setSort() {
      this.sort = (this.sort === 1) ? -1 : 1;
    },
  }
}
</script>

<style>
</style>
